import styles from "./in-page-links.module.less";

export type TInPageLink = {
  anchor: string;
  title: string;
};

type TInPageLinksProps = {
  title: string;
  links: Array<TInPageLink>;
};

const InPageLinks = ({ title, links }: TInPageLinksProps) => {
  return (
    <div className={styles.wrapper}>
      <p className={`${styles.title} body-s bold`}>{title}</p>
      <ul className={styles.links}>
        {links.map((link) => {
          return (
            <li key={link.title} className={styles.listItem}>
              <a className={styles.link} href={link.anchor}>
                {link.title}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export { InPageLinks };

export default InPageLinks;
